<template>
    <div />
</template>

<script>
export default {
  name: "Dummy"
}
</script>
